import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 update_promotion_code_lookup_integration_settings: { message: "idle" },
};

export const update_promotion_code_lookup_integration_settings_Slice = createSlice({
 name: "update_promotion_code_lookup_integration_settings",
 initialState,
 reducers: {
  success_update_promotion_code_lookup_integration_settings: (state, action) => {
   state.update_promotion_code_lookup_integration_settings = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_update_promotion_code_lookup_integration_settings: (state, action) => {
   state.update_promotion_code_lookup_integration_settings = { status: app_consts.FAIL, message: action.payload };
  },
  reset_update_promotion_code_lookup_integration_settings: (state) => {
   state.update_promotion_code_lookup_integration_settings = { status: app_consts.IDLE };
  },
  loading_update_promotion_code_lookup_integration_settings: (state) => {
   state.update_promotion_code_lookup_integration_settings = { status: app_consts.LOADING };
  },
 }
});

export const { success_update_promotion_code_lookup_integration_settings, fail_update_promotion_code_lookup_integration_settings, reset_update_promotion_code_lookup_integration_settings, loading_update_promotion_code_lookup_integration_settings } = update_promotion_code_lookup_integration_settings_Slice.actions;

export default update_promotion_code_lookup_integration_settings_Slice.reducer;